export const buildNumber = '20260212.1';
export const version = 'main';
export const latestCommit = '7f7126d17a6d6a42160e0662f0ad625bc2838b43';
